// @ts-check

import React from "react";
import { Card, EmptySearchResult, IndexTable, InlineStack, Spinner, Text, useBreakpoints } from "@shopify/polaris";
import { TopParametersTableRow } from "./TopParametersTableRow";

export const TopParametersTable = ({
  parameters,
  parameterKey,
  totalCount,
  page,
  setPage,
  pageSize,
  resourceName,
  loading,
  calculateParameterReportHref,
}) => {

  const headings = [
    {
      id: resourceName.singular,
      title: resourceName.singular,
    },
    {
      id: "Orders",
      title: "Orders",
      alignment: "end",
    },
    {
      id: "Revenue",
      title: "Revenue",
      alignment: "end",
    },
  ];

  const emptyStateMarkup = (
    <EmptySearchResult
      title={`No ${resourceName.plural} yet`}
      description={`You might not have received any orders for this ${resourceName.singular}. Try adjusting the date range in the top left.`}
      withIllustration
    />
  );

  const totalPages = ~~(totalCount / pageSize) + 1;

  const paginationLabel = (
    <InlineStack gap="300" align="center">
      <Text fontWeight="semibold" as="p">Page {page} of {totalPages}</Text>
      <Text as="p">Showing {parameters.length} of {new Intl.NumberFormat("en-US").format(totalCount)} {resourceName.plural}</Text>
      {loading && <Spinner size="small" />}
    </InlineStack>
  );

  return (
    <Card padding="0">
      <IndexTable
        condensed={useBreakpoints().smDown}
        resourceName={{ singular: "created UTM link", plural: "created UTM links" }}
        itemCount={parameters.length}
        selectable={false}
        emptyState={emptyStateMarkup}
        headings={headings}
        lastColumnSticky
        pagination={{
          label: paginationLabel,
          hasPrevious: page > 1,
          hasNext: pageSize * page < totalCount,
          onNext: () => {
            setPage(page => Math.min(totalPages, page + 1));
          },
          onPrevious: () => {
            setPage(page => Math.max(0, page - 1));
          },
        }}
      >
        {parameters.map((row, index) => (
          <TopParametersTableRow
            key={row[parameterKey]}
            index={index}
            data={row}
            parameterKey={parameterKey}
            calculateParameterReportHref={calculateParameterReportHref}
          />
        ))}
      </IndexTable>
    </Card>
  );
};
